import { render, staticRenderFns } from "./AddProductsBySkuTab.vue?vue&type=template&id=57a5dae6"
import script from "./AddProductsBySkuTab.vue?vue&type=script&lang=js"
export * from "./AddProductsBySkuTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports